// AI Generated Test
import { Component, forwardRef, Input, OnInit, ElementRef, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'form-field-radio-in-line',
    templateUrl: './form-field-radio-in-line.component.html',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormFieldRadioInLineComponent),
            multi: true,
        },
    ],
})
export class FormFieldRadioInLineComponent implements OnInit, ControlValueAccessor, AfterViewInit {
    @Input() label: string = '';
    @Input() helpTxt: string = '';
    @Input() options: any[] = [];
    @Input() returnValue: string = 'name';
    @Input() ngRequired: boolean = false;
    @Input() name: string = '';

    @Output() ngChange = new EventEmitter<any>();

    @ViewChild('formGroupRef', { static: true }) formGroupRef!: ElementRef;

    private _value: any = '';
    private _onChange = (value: any) => {};
    private _onTouched = () => {};
    public _isTouched = false;

    constructor (private elementRef: ElementRef) {}

    ngOnInit (): void {
        this.returnValue = this.returnValue || 'name';
        this.ngRequired = this.ngRequired || false;

        // Initialize with first option value if no value is set
        if (!this._value && this.options && this.options.length > 0) {
            this._value = this.options[0][this.returnValue];
        }
    }

    ngAfterViewInit (): void {
        // Initialize validation state after view is ready
        this.updateValidationClasses();
    }

    get value (): any {
        return this._value;
    }

    set value (val: any) {
        if (val !== this._value) {
            this._value = val;
            this._onChange(val);
            this._onTouched();
        }
    }

    writeValue (value: any): void {
        if (value !== undefined && value !== null) {
            this._value = value;
        } else if (this.options && this.options.length > 0) {
            this._value = this.options[0][this.returnValue];
        }
    }

    registerOnChange (fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched (fn: any): void {
        this._onTouched = fn;
    }

    setDisabledState (isDisabled: boolean): void {
        // Handle disabled state if needed
    }

    onRadioChange (value: any): void {
        this.value = value;
        this._isTouched = true;
        this.updateValidationClasses();
        this.ngChange.emit(this.value);
    }

    onRadioFocusOut (): void {
        this._isTouched = true;
        this._onTouched();
        this.updateValidationClasses();
    }

    isFieldValid (): boolean {
        if (this.ngRequired && (!this._value || this._value === '')) {
            return false;
        }
        return true;
    }

    public updateValidationClasses (): void {
        if (!this.formGroupRef) {
            return;
        }

        const formGroupElement = this.formGroupRef.nativeElement;
        const isValid = this.isFieldValid();

        if (!isValid && this._isTouched) {
            this.setHasError(formGroupElement);
        } else {
            this.removeHasError(formGroupElement);
        }
    }

    private setHasError (formGroupElement: HTMLElement): void {
        if (!formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.add('has-error');
        }
    }

    private removeHasError (formGroupElement: HTMLElement): void {
        if (formGroupElement.classList.contains('has-error')) {
            formGroupElement.classList.remove('has-error');
        }
    }
}
